import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./components/AdminLogin";
import AdminSignup from "./components/AdminSignup";
import AdminCallback from "./components/AdminCallback";
import AdminMain from "./components/AdminMain";
import AdminCarts from "./components/AdminCarts";
import AdminProductAdd from "./components/AdminProductAdd";
import AdminImageAdd from "./components/AdminImageAdd";
import AdminEvents from "./components/AdminEvents";
import AdminRestaurant from "./components/AdminRestaurant";
import AdminRestaurantBooking from "./components/AdminRestaurantBooking";
import AdminNewsletter from "./components/AdminNewsletter";
import { SearchProvider } from './components/AdminSearchContext';

if(window.location.hash) {
  const cleanUrl = window.location.origin + '/Login';
  window.history.replaceState({}, document.title, cleanUrl);
  window.location.href = cleanUrl; // Force le rechargement
}

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/Login" replace />} />
        <Route path="/Login" element={<AdminLogin />} />
        <Route path="/Signup" element={<AdminSignup />} />
        <Route path="/AdminCallback" element={<AdminCallback />} />

        <Route path="/Commandes" element={
          <SearchProvider>
            <AdminMain>
              <AdminCarts />
            </AdminMain>
          </SearchProvider>
        } />
        
        <Route path="/AjouterProduit" element={
          <SearchProvider>
            <AdminMain>
              <AdminProductAdd />
            </AdminMain>
          </SearchProvider>
        } />
        
        <Route path="/AjouterImage" element={
          <SearchProvider>
            <AdminMain>
              <AdminImageAdd />
            </AdminMain>
          </SearchProvider>
        } />
        
        <Route path="/AjouterEvenement" element={
          <SearchProvider>
            <AdminMain>
              <AdminEvents />
            </AdminMain>
          </SearchProvider>
        } />
        
        <Route path="/AjouterPlat" element={
          <SearchProvider>
            <AdminMain>
              <AdminRestaurant />
            </AdminMain>
          </SearchProvider>
        } />
        
        <Route path="/ReservationRestaurant" element={
          <SearchProvider>
            <AdminMain>
              <AdminRestaurantBooking />
            </AdminMain>
          </SearchProvider>
        } />

        <Route path="/Newsletter" element={
          <SearchProvider>
            <AdminMain>
              <AdminNewsletter />
            </AdminMain>
          </SearchProvider>
        } />

        <Route path="*" element={<Navigate to="/Login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;